import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { ErrorDetailMessage } from "@context-providers/error-boundary/error-detail-message";
import { WarningIcon, Dialog, Text } from "@flat-ui";
import { removeOne } from "@store/errors/errors-slice";
import { useAppDispatch } from "@store/store-helper";
/**
 * Displays an error message in a Dialog with a close button.
 */
export function ErrorDialog(t0) {
  const $ = _c(18);
  const {
    error,
    onClose
  } = t0;
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] !== dispatch || $[1] !== error.id || $[2] !== onClose) {
    t1 = function onCloseHandler() {
      dispatch(removeOne(error.id));
      onClose();
    };
    $[0] = dispatch;
    $[1] = error.id;
    $[2] = onClose;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onCloseHandler = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <><WarningIcon sx={{
        marginRight: "10px"
      }} />An unexpected error occurred</>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      mt: SPACE_ELEMENTS_OF_MODAL
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== error.title) {
    t4 = <Text variant="heading20" sx={t3}>{error.title}</Text>;
    $[6] = error.title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <b>Developer Error Message:</b>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== error.error) {
    t6 = <Text variant="bodyM" component="div" gutterBottom={true}>{t5}<ErrorDetailMessage error={error.error} /></Text>;
    $[9] = error.error;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== error.id || $[15] !== onCloseHandler || $[16] !== t7) {
    t8 = <Dialog key={error.id} open={true} onConfirm={onCloseHandler} title={t2} confirmText="OK">{t7}</Dialog>;
    $[14] = error.id;
    $[15] = onCloseHandler;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}